import React, {ReactChild, useState} from 'react';
import {error, success} from "../common/colors";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'glamor';
import LoadingOverlay from "../common/components/LoadingOverlay";
import useConfirmationDialog from "../common/hooks/useConfirmationDialog";
import ConfirmationDialog from "../common/components/ConfirmationDialog";

type ApplicationFlowContext = {
    isLoading: boolean,
    setIsLoading: (isLoading: boolean) => void,
    displaySuccessMessage: (message: string) => void,
    displayErrorMessage: (message: string) => void,
    openConfirmationDialog: (dialogInfos: {onConfirm: () => void, text: string, buttonText: string}) => void,
    organizationId: number | null
}

const displaySuccessNotification = (message: string) => {
    toast.success(message, {
        className: css({
            background: success,
            paddingLeft: '20px'
        })
    });
};
const displayErrorNotification = (message: string) => {
    toast.error(message, {
        className: css({
            background: error,
            paddingLeft: '20px'
        })
    });
};

export const ApplicationFlowContext = React.createContext<ApplicationFlowContext>({
    isLoading: false,
    setIsLoading: () => {},
    displaySuccessMessage: () => {},
    displayErrorMessage: () => {},
    openConfirmationDialog: () => {},
    organizationId: null
});

interface ApplicationFlowContextProviderProps {
    children: ReactChild,
    organizationId: number | null
}

const ApplicationFlowContextProvider = ({children, organizationId}: ApplicationFlowContextProviderProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openConfirmationDialog, closeConfirmationDialog, isConfirmationModalOpen, dialogInfos] = useConfirmationDialog();

    return (
        <>
            <ApplicationFlowContext.Provider value={{
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                displaySuccessMessage: displaySuccessNotification,
                displayErrorMessage: displayErrorNotification,
                openConfirmationDialog: openConfirmationDialog,
                organizationId
            }}>
                {children}
            </ApplicationFlowContext.Provider>
            <ToastContainer autoClose={5000}/>
            {isLoading && (<LoadingOverlay/>)}
            {isConfirmationModalOpen && dialogInfos && (<ConfirmationDialog confirmationText={dialogInfos.text} buttonConfirmationText={dialogInfos.buttonText} onConfirmation={dialogInfos.onConfirm} close={closeConfirmationDialog} />)}
        </>

    )
};

export default ApplicationFlowContextProvider;
